import { Box, Button, Divider, Paper, Typography } from '@mui/material';
import { Handle } from '@remix-run/router';
import { Link, useMatches } from 'react-router-dom';
import { tss } from 'tss-react/mui';
import { InstagramFooter } from './InstagramFooter';
import { SocialMediaIcons } from './SocialMediaIcons';
import { useCookies } from '../cookiesfooter/CookiesProvider';

export const Footer: React.FC = () => {
  const matches = useMatches();
  const { classes } = useStyles();
  const handle = matches[matches.length - 1]?.handle as Handle | undefined;
  const { setShouldShowCookies } = useCookies();
  return (
    <Paper>
      {!handle?.hideInstaFooter && <InstagramFooter />}
      <Divider />
      <Box className={classes.wrapper} sx={{ mx: 3, my: 2 }}>
        <Typography>UX-Beauty by Givaudan</Typography>
        <Box
          className={classes.innerWrapper}
          sx={{
            gap: 1
          }}
        >
          <SocialMediaIcons />
          <div>
            <Button variant="text" component={Link} to="/legal-notice">
              Legal Notice
            </Button>

            <Button
              variant="text"
              onClick={() => {
                setShouldShowCookies(true);
              }}
            >
              Cookie Preferences
            </Button>
          </div>
        </Box>
      </Box>
    </Paper>
  );
};
const useStyles = tss.create(({ theme }) => ({
  wrapper: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',

    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column'
    }
  },
  innerWrapper: {
    display: 'flex',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      alignItems: 'center',
      marginTop: '8px'
    }
  }
}));
